import { OpaqueToken } from "@angular/core";
const version = "2";
export const MODULE_VERSIONS = new OpaqueToken('moduleVersions');
export const DataClientVersion = {
    provide: MODULE_VERSIONS,
    useValue: {
        "module": "data-client-api",
        "version": version
    },
    multi: true
};
//# sourceMappingURL=versions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/versioning/versions.js
// module id = 216
// module chunks = 1